import type {SelectOptionItem} from '@yandex-delivery/blocks'
import {Loader, Select} from '@yandex-delivery/blocks'
import {useController, useFormContext} from '@yandex-delivery/form'
import {formatDate, pipe} from '@yandex-delivery/utils'
import React, {useMemo} from 'react'

import {i18n} from 'src/shared/config'
import {toDate} from 'src/shared/utils'

import type {Props} from './DeliveryDateSelect.types'

export function DeliveryDateSelect(props: Props): React.ReactElement {
  const {name, 'data-testid': dataTestId, dates, isLoading = false, noFormat = false} = props
  const {control} = useFormContext()
  const {field, fieldState} = useController({control, name})

  const options = useMemo<Array<SelectOptionItem<string>>>(() => {
    if (noFormat) {
      return dates.map(date => ({
        label: date,
        value: date,
      }))
    }

    return dates.map(date => {
      const formattedDate = pipe(
        date,
        toDate,
        formatDate({
          sameDay: i18n('cargo.create.delivery-interval.today', '[Сегодня,] D MMMM'),
          nextDay: i18n('cargo.create.delivery-interval.tomorrow', '[Завтра,] D MMMM'),
          nextWeek: 'D MMMM',
          sameElse: 'D MMMM',
        }),
      )

      return {
        label: formattedDate,
        value: date,
      }
    })
  }, [dates, noFormat])

  return (
    <Select<string>
      data-testid={dataTestId}
      error={fieldState.invalid}
      helperText={fieldState.error?.message}
      onBlur={field.onBlur}
      onChange={selected => {
        field.onChange(selected?.value)
      }}
      options={options}
      placeholder={i18n('cargo.create.due.select-date', 'Выберите дату')}
      trail={isLoading && <Loader />}
      value={typeof field.value === 'string' ? field.value : undefined}
    />
  )
}
